module.exports = __webpack_public_path__ + "img/2.0395fb6e.png";